<template>
  <div class="admin-boutique">
    <h1 class="title">Gestion Boutique :</h1>
    <b-field position="is-centered" class="buttons" grouped>
      <b-button class="is-vert" @click="ajoutProduitModal()"
        >Ajouter un produit</b-button
      >
      <b-button class="is-info" @click="gestionTypeModal()"
        >Gestion des types de produit.</b-button
      >
    </b-field>
    <b-taglist>
      <b-tag type="is-primary">{{ userNumber }} utilisateurs inscrits</b-tag>

      <b-tag type="is-success"
        >{{ moneyEarned }}€ gagné depuis la création du site</b-tag
      >
    </b-taglist>
    <b-collapse
      class="card"
      animation="slide"
      aria-id="contentIdForA11y3"
      :open="isOpen == idCollapseUpdate"
      @open="isOpen = idCollapseUpdate"
    >
      <div
        slot="trigger"
        slot-scope="props"
        class="card-header"
        role="button"
        aria-controls="contentIdForA11y3"
      >
        <h2 class="card-header-title is-size-3">
          Mettre à jour ou supprimer un produit.
        </h2>
        <a class="card-header-icon">
          <b-icon :icon="props.open ? 'caret-up' : 'caret-down'"></b-icon>
        </a>
      </div>
      <div class="card-content">
        <AdminListeProduits />
      </div>
    </b-collapse>
    <b-collapse
      class="card"
      animation="slide"
      aria-id="contentIdForA11y3"
      :open="isOpen == idCollapseMessages"
      @open="isOpen = idCollapseMessages"
    >
      <div
        slot="trigger"
        slot-scope="props"
        class="card-header"
        role="button"
        aria-controls="contentIdForA11y3"
      >
        <h2 class="card-header-title is-size-3">Voir les messages reçus.</h2>
        <a class="card-header-icon">
          <b-icon :icon="props.open ? 'caret-up' : 'caret-down'"></b-icon>
        </a>
      </div>
      <div class="card-content">
        <AdminListeMessages />
      </div>
    </b-collapse>
    <b-collapse
      class="card"
      animation="slide"
      aria-id="contentIdForA11y3"
      :open="isOpen == idCollapseVentes"
      @open="isOpen = idCollapseVentes"
    >
      <div
        slot="trigger"
        slot-scope="props"
        class="card-header"
        role="button"
        aria-controls="contentIdForA11y3"
      >
        <h2 class="card-header-title is-size-3">Voir les ventes.</h2>
        <a class="card-header-icon">
          <b-icon :icon="props.open ? 'caret-up' : 'caret-down'"></b-icon>
        </a>
      </div>
      <div class="card-content">
        <AdminListeVentes />
      </div>
    </b-collapse>
  </div>
</template>

<script>
// @ is an alias to /src
import AdminListeProduits from "@/components/AdminListeProduits.vue";
import AdminListeMessages from "@/components/AdminListeMessages.vue";
import AdminListeVentes from "@/components/AdminListeVentes.vue";
import AdminAjoutProduit from "@/components/AdminAjoutProduit.vue";
import AdminGestionType from "@/components/AdminGestionType.vue";
import ListeTypes from "../classes/ListeTypes.js";

const { getNumberProfiles, moneyEarned } = require("../classes/Compteur.js");
export default {
  name: "Home",
  components: {
    AdminListeProduits,
    AdminListeMessages,
    AdminListeVentes,
  },
  data() {
    return {
      isOpen: -1,
      idCollapseAdd: 1,
      idCollapseUpdate: 2,
      idCollapseMessages: 3,
      idCollapseVentes: 4,
    };
  },
  created() {
    this.updateListeTypes();
  },
  asyncComputed: {
    userNumber: async function () {
      return await getNumberProfiles();
    },
    moneyEarned: async function () {
      return await moneyEarned();
    },
  },
  methods: {
    updateListeTypes: async function () {
      const maListe = new ListeTypes();
      await maListe.getTypes();
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      }
      return false;
    },
    ajoutProduitModal() {
      this.$buefy.modal.open({
        parent: this,
        component: AdminAjoutProduit,
        width: 1600,
        fullScreen: this.isMobile() ? true : false,
      });
    },
    gestionTypeModal() {
      this.$buefy.modal.open({
        parent: this,
        component: AdminGestionType,
        width: 1600,
      });
    },
  },
};
</script>